/**
 * Login type - page redirect or modal
 */
export type LoginType = 'page' | 'modal';

/**
 * Endpoint keys for session service - uses COMMON app keys
 */
export const SessionEndpointKeys = {
  LOGIN_URL: 'LOGIN_URL',
  DASHBOARD_BFF_URL: 'DASHBOARD_BFF_URL'
} as const;

/**
 * OAuth feature configuration for specifying which auth config URL to use.
 * Used to inject the correct auth config endpoint for different applications.
 *
 * Example:
 * { app: 'MARKETPLACE_MILES', endpointKey: 'MILES_LOGIN_AUTH_CONFIG' }
 */
export interface OAuthFeatureConfig {
  /** The app key in the config (e.g., 'MARKETPLACE_MILES') */
  app: string;
  /** The endpoint key within the app config (e.g., 'MILES_LOGIN_AUTH_CONFIG') */
  endpointKey: string;
}
